export default __webpack_public_path__ + "static/media/Caras.8711b104.jpg";